import React from 'react';
import PropTypes from 'prop-types';

const Select = props => (
  <div className="select-wrapper">
    <select
      name={props.name}
      onChange={props.controlFunc}
    >
      {props.options.map(opt => <option key={opt.title} value={opt.value}>{opt.title}</option>)}
    </select>
  </div>
);

Select.propTypes = {
  name: PropTypes.string,
  controlFunc: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.array]),
};

Select.defaultProps = {
  name: '',
  controlFunc: () => true,
  options: [],
};

export default Select;
